import { render, staticRenderFns } from "./heatmap-3d.vue?vue&type=template&id=ab175a56&"
import script from "./heatmap-3d.vue?vue&type=script&lang=js&"
export * from "./heatmap-3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports